import type { InferDefaults } from '@/helpers/vue.ts'

export interface Props {
    modelValue: InputRangeModel
    min?: number
    max?: number
    clamp?: { min: number; max: number }
    minLabel?: string | number
    maxLabel?: string | number
    step?: number
    label?: string
    valueFormatter?: InputRangeTwoKnobbedValueFormatter
    disabled?: boolean
}

export const defaults = {
    modelValue: (): InputRangeModel => [0, 100],
    min: 0,
    max: 100,
    clamp: undefined,
    minLabel: undefined,
    maxLabel: undefined,
    step: 1,
    label: undefined,
    valueFormatter: (val: number) => String(val),
} as const satisfies InferDefaults<Props>

export type InputRangeModelEntry = number | undefined | null
export type InputRangeModel = [InputRangeModelEntry, InputRangeModelEntry]
export type InputRangeTwoKnobbedIndex = 0 | 1
export type InputRangeTwoKnobbedValueFormatter = (
    value: number,
    index: InputRangeTwoKnobbedIndex
) => string
export type InputElementIndex = 0 | 1
export type UpdateSingleInputUiValue = (
    value: number,
    index?: InputElementIndex
) => void
